module.exports = __webpack_public_path__ + "media/images/sp/stores/tachikawa/tachikawa_sns_03-11d240bd3838560f24b27b914555a79e.jpg";